import React, { Fragment } from "react";

import Page from "../../components/Page";
import CompanyList from "../../components/CompanyList";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import CenteredPageContentContainer from "../../components/CenteredPageContentContainer";
import PaperContainer from "../../components/PaperContainer";

const CompanyPage = () => (
  <Page title="Bedrijven">
    <Fragment>
      <CenteredPageContentContainer>
        <PaperContainer title="Bedrijven">
          <CompanyList />
        </PaperContainer>
      </CenteredPageContentContainer>
      <Fab
        variant="circular"
        color="primary"
        style={{ position: "fixed", bottom: 40, right: 40 }}
        onClick={() => {
          window.location.href = `/company/create`;
        }}
      >
        <AddIcon />
      </Fab>
    </Fragment>
  </Page>
);

export default CompanyPage;



// WEBPACK FOOTER //
// ./src/pages/Company/CompanyPage.js